<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M13 2L4.5 13.5h6L9 22l9-12h-6L13 2z" />
  </svg>
</template>

<script>
export default {
  name: 'IconBolt',
  props: { size: { type: [String, Number], default: 22 } },
};
</script>
